import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Col } from "antd";

import InquiryApi from "../apis/Inquiry.api";
import salesManageApi from "../apis/SalesManage.api";
import ContentHeaderComponent from "../components/layout/ContentHeaderComponent";
import AnswerDashboard from "../components/page/main/dashboard/AnswerDashboard";
import CancelDashboard from "../components/page/main/dashboard/CancelDashboard";
import MainDashboard from "../components/page/main/dashboard/MainDashboard";
import ReviewDashboard from "../components/page/main/dashboard/ReviewDashboard";
import StatisticsDashboard from "../components/page/main/dashboard/StatisticsDashboard";
import UserDashboard from "../components/page/main/dashboard/UserDashboard";
import { setLoading } from "../redux/store/common/commonDuck";

const MainPage = () => {
  const dispatch = useDispatch();
  const setIsLoading = (value) => dispatch(setLoading(value));
  const user = useSelector((state) => state.auth.user);

  // const mainDashBoardLoading = useRef(false);
  const [orderLoading, setOrderLoading] = useState(true);

  // const [trendData, setTrendData] = useState(null);
  const [orderDeliveryStatus, setOrderDeliveryStatus] = useState({
    newOrder: 0,
    deliveryReady: 0,
    deliveryShipping: 0,
    deliveryComplete: 0,
    cancelRequest: 0,
    returnRequest: 0,
    returnDeliveryComplete: 0,
    returnCollectionFail: 0,
    returnDelay: 0,
    returnRefundDelay: 0,
  });
  const [inquiryStatus, setInquiryStatus] = useState({
    productInquiryList: [],
    productInquiryCnt: 0,
    csInquiryList: [],
    csCnt: 0,
    pharmacyInquiryList: [],
    pharmacyInquiryCnt: 0,
    recommendInquiryList: [],
    recommendInquiryCnt: 0,
  });

  useEffect(() => {
    setIsLoading(true);
    // getTrend();
    getOrderDeliveryStatus();
    getUnansweredProductQuestion();
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  /**
   * 주문/배송 현황 가져오기 (2022.11.04) - ksb
   * + 반품 관련 추가된 상태값 반영 (2023.08.08) - ksb
   */
  const getOrderDeliveryStatus = async () => {
    setOrderLoading(true);
    const param = {
      userId: user.id === 724 ? 1 : user.id,
      page: "home",
    };
    const res = await salesManageApi.salesManageStatus(param);
    if (res.code === 200) {
      setOrderDeliveryStatus({
        ...orderDeliveryStatus,
        newOrder: res.result.newOrderCnt,
        deliveryReady: res.result.deliveryReadyCnt,
        deliveryShipping: res.result.deliveryShippingList,
        deliveryShipping7delay: res.result.deliveryShippingPassed7DaysCnt,
        deliveryComplete: res.result.deliveryCompleteList,
        delivery12: res.result.deliveryReadyPassed12Cnt,
        delivery24: res.result.deliveryReadyPassed24Cnt,
        cancelRequest: res.result.cancelRequestCnt,
        returnRequest: res.result.returnRequestCnt,
        returnDeliveryComplete: res.result.returnShippingCompleteCnt,
        returnCollectionFail: res.result.returnCollectionFailCnt,
        returnDelay: res.result.returnDelayCnt,
        returnRefundDelay: res.result.returnRefundDelayCnt,
        returnReceiveCnt: res.result.returnReceiveCnt,
      });
    }
    setOrderLoading(false);
  };

  /**
   * 미답변 상품문의 및 고객문의 현황 가져오기 (2022.11.07) - ksb
   */
  const getUnansweredProductQuestion = async () => {
    const param = {
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await InquiryApi.unAnsweredInquiryStatus(param);
    if (res.code === 200) {
      setInquiryStatus({
        ...inquiryStatus,
        productInquiryList: res.result.findProductInquiryList,
        productInquiryCnt: res.result.productInquiryListCnt,
        csInquiryList: res.result.findCsInquiryList,
        csCnt: res.result.total,
        pharmacyInquiryList: res.result.findPharmacyInquiryList.slice(0, 5),
        pharmacyInquiryCnt: res.result.findPharmacyInquiryList?.length,
        recommendInquiryList: res.result.findRecommendInquiryList.slice(0, 5),
        recommendInquiryCnt: res.result.findRecommendInquiryList?.length,
      });
    }
  };

  return (
    <>
      <ContentHeaderComponent title="대시보드" />
      {user && user.role && user.role === "super_admin" ? (
        <div className="main-page-content-wrap order-component-wrap">
          <div className={`order-component-body flexColumn`}>
            {/* 판매/배송 */}
            <MainDashboard
              orderDeliveryStatus={orderDeliveryStatus}
              orderLoading={orderLoading}
            />

            <Col
              className={`main-component-col`}
              style={{ height: "fit-content", minHeight: "auto" }}
            >
              {/* 반품/교환 */}
              <CancelDashboard orderDeliveryStatus={orderDeliveryStatus} />

              {/* 미답변문의 */}
              <AnswerDashboard inquiryStatus={inquiryStatus} />
            </Col>

            {/* 리뷰 */}
            <ReviewDashboard />
          </div>

          <div className={`order-component-body flexColumn`}>
            {/* 가입/유입 통계 */}
            <UserDashboard />

            {/* 매출/판매 통계 */}
            <StatisticsDashboard />

            {/* 방문자 경로 */}
            {/*<VisitorDashboard/>*/}

            {/* 구매자 경로 */}
            {/*<BuyerDashboard/>*/}
          </div>
          {/*<Row>*/}
          {/*    <Col span={12} className="dashboard-content-wrap">*/}
          {/*        {trendData && (<UserManageComponent />)}*/}
          {/*    </Col>*/}
          {/*    <Col span={12} style={{ display: "flex" }}>*/}
          {/*        <Col span={12} className="dashboard-content-wrap">*/}
          {/*            <OrderDeliveryManageComponent orderDeliveryStatus={orderDeliveryStatus} />*/}
          {/*        </Col>*/}
          {/*        <Col span={12} className="dashboard-content-wrap">*/}
          {/*            <ClaimSettlementComponent orderDeliveryStatus={orderDeliveryStatus} />*/}
          {/*        </Col>*/}
          {/*    </Col>*/}
          {/*</Row>*/}
          {/*<Row>*/}
          {/*    <Col span={12} className="dashboard-content-wrap">*/}
          {/*        <InquiryComponent inquiryStatus={inquiryStatus} />*/}
          {/*    </Col>*/}
          {/*    <Col span={12} className="dashboard-content-wrap">*/}
          {/*        <ReviewComponent />*/}
          {/*    </Col>*/}
          {/*</Row>*/}
        </div>
      ) : (
        <div className="main-page-content-wrap order-component-wrap">
          <div className={`order-component-body flexColumn`}>
            {/* 판매/배송 */}
            <MainDashboard
              orderDeliveryStatus={orderDeliveryStatus}
              orderLoading={orderLoading}
            />

            <Col
              className={`main-component-col`}
              style={{ height: "fit-content", minHeight: "auto" }}
            >
              {/* 반품/교환 */}
              <CancelDashboard orderDeliveryStatus={orderDeliveryStatus} />

              {/* 미답변문의 */}
              <AnswerDashboard inquiryStatus={inquiryStatus} />
            </Col>

            {/* 리뷰 */}
            <ReviewDashboard />
          </div>

          <div className={`order-component-body flexColumn`}>
            {/* 매출/판매 통계 */}
            <StatisticsDashboard />
          </div>
          {/*<Row>*/}
          {/*    <Col span={12} className="dashboard-content-wrap">*/}
          {/*        {trendData && (<UserManageComponent />)}*/}
          {/*    </Col>*/}
          {/*    <Col span={12} style={{ display: "flex" }}>*/}
          {/*        <Col span={12} className="dashboard-content-wrap">*/}
          {/*            <OrderDeliveryManageComponent orderDeliveryStatus={orderDeliveryStatus} />*/}
          {/*        </Col>*/}
          {/*        <Col span={12} className="dashboard-content-wrap">*/}
          {/*            <ClaimSettlementComponent orderDeliveryStatus={orderDeliveryStatus} />*/}
          {/*        </Col>*/}
          {/*    </Col>*/}
          {/*</Row>*/}
          {/*<Row>*/}
          {/*    <Col span={12} className="dashboard-content-wrap">*/}
          {/*        <InquiryComponent inquiryStatus={inquiryStatus} />*/}
          {/*    </Col>*/}
          {/*    <Col span={12} className="dashboard-content-wrap">*/}
          {/*        <ReviewComponent />*/}
          {/*    </Col>*/}
          {/*</Row>*/}
        </div>
      )}
    </>
  );
};

export default MainPage;
